import { gql } from 'graphql-request';

import { axios } from '../../../app/Axios';
import { environment } from 'src/environments';
import { graphqlRequest } from 'src/app/graphqlClient';
import { EventServicePageNameTypes } from '../ManageColumnsPopup/queries/apiTypes';

const endpoint = '/api/hasura/auth';
const dropdownEndpoints: { [key: string]: string } = {
    company: '/rolodex/company_drop_down/',
    contact: '/rolodex/contact_drop_down/'
};

export const getFeatureFlagQuery = async (email?: string, company_group_id?: string) => {
    const queryString = gql`
        query GetFeatureFlag($email: [String]!, $company_group_id: [String]!) {
            feature_flag_db {
                flags(
                    where: {
                        flag_segments: {
                            segment: { _or: [{ attribute: { _eq: "email" }, values: { _contains: $email } }, { attribute: { _eq: "company_group_id" }, values: { _contains: $company_group_id } }] }
                        }
                    }
                ) {
                    name
                }
            }
        }
    `;
    const response = await graphqlRequest({
        document: queryString,
        variables: { email: [email], company_group_id: [company_group_id] }
    });
    return response.feature_flag_db;
};

export const getMaintenanceData = async () => {
    const queryString = gql`
        query {
            events_db {
                app_maintenance {
                    end_date_time
                    is_under_maintenance
                }
            }
        }
    `;
    const response = await graphqlRequest({ document: queryString }, false);
    return response.events_db;
};

export const getSelectedFilters = async (userId: number, pageName: string) => {
    const queryString = gql`
        query GetSelectedFilters($userId: Int!, $pageName: page_name_type!) {
            events_db {
                table_settings_by_pk(page_name: $pageName, user_id: $userId) {
                    filters
                }
            }
        }
    `;
    const response = await graphqlRequest({
        document: queryString,
        variables: { userId, pageName }
    });

    return response.events_db;
};

interface UpdateSelectedFiltersArg {
    filters: Record<string, any>;
    pageName: string;
}

export const updateSelectedFilters = async ({ filters, pageName }: UpdateSelectedFiltersArg) => {
    const upsertMutationString = gql`
        mutation UpsertSelectedFilters($filters: jsonb!, $pageName: page_name_type!) {
            events_db {
                insert_table_settings(objects: { filters: $filters, page_name: $pageName }, on_conflict: { constraint: table_settings_pkey, update_columns: [filters] }) {
                    affected_rows
                }
            }
        }
    `;
    return graphqlRequest({
        document: upsertMutationString,
        variables: { filters, pageName }
    });
};

export const fetchHasuraToken = () => {
    return axios.post(endpoint);
};

export const getDeploymentInfo = async () => {
    const res = await fetch(environment.N, {
        headers: {
            'Cache-Control': 'no-cache'
        }
    });

    const data = await res.json();
    return data;
};

export const getCompanyDropdownList = () => {
    return axios.get(dropdownEndpoints.company);
};

export const getContactDropdownList = () => {
    return axios.get(dropdownEndpoints.contact);
};

interface AppPerformanceData {
    apiResponseTime: number;
    uiResponseTime: number;
    country: string;
    apiUrl: string;
    apiType: 'GET' | 'PUT' | 'POST' | 'PATCH' | 'DELETE';
}

export async function pushAppPerformanceEvent({ apiResponseTime, uiResponseTime, country, apiUrl, apiType }: AppPerformanceData) {
    const queryString = gql`
        mutation PushAppPerformanceEvent($apiResponseTime: Int!, $uiResponseTime: Int!, $country: String!, $apiUrl: String!, $apiType: api_request_method_type!) {
            events_db {
                insert_app_performance_v2(objects: { api_latency_ms: $apiResponseTime, api_ui_latency_ms: $uiResponseTime, country: $country, api_req_url: $apiUrl, api_req_method_type: $apiType }) {
                    affected_rows
                }
            }
        }
    `;

    const variables = {
        apiResponseTime,
        uiResponseTime,
        country,
        apiUrl,
        apiType
    };

    return graphqlRequest({ document: queryString, variables });
}

export const getSelectedColumnsAndFilters = async (payload: { userId: number; pageName: EventServicePageNameTypes }) => {
    const queryString = `
        query GetSelectedColumnsAndFilters($userId: Int!, $pageName: page_name_type!) {
            events_db {
                table_settings(where: { page_name: {_eq: $pageName}, user_id: { _eq: $userId } }) {
                    order,
                    filters,
                    sort_field,
                    width,
                }
            }
        }
    `;
    const variables = { userId: payload.userId, pageName: payload.pageName };
    const response = await graphqlRequest({ document: queryString, variables });
    return response.events_db;
};
